import type { Action } from "redux"

// =============================================================================
// Actions
// -----------------------------------------------------------------------------

export enum SettingsActionTypes {
    DriftmeldingLoading = "app-driftmelding:loading",
    DriftmeldingLoaded = "app-driftmelding:loaded",
    DriftmeldingSuccess = "app-driftmelding:success",
    DriftmeldingError = "app-driftmelding:error",

    InfoBannerLoading = "app-info-banner:loading",
    InfoBannerLoaded = "app-info-banner:loaded",
    InfoBannerSuccess = "app-info-banner:success",
    InfoBannerError = "app-info-banner:error",

    HideMaintenanceMessage = "app-settings:hide-maintenance-message",
}

export type DriftmeldingLoadingAction = Action<SettingsActionTypes.DriftmeldingLoading>
export type DriftmeldingLoadedAction = Action<SettingsActionTypes.DriftmeldingLoaded>

export interface DriftmeldingSuccessAction extends Action<SettingsActionTypes.DriftmeldingSuccess> {
    payload: DriftmeldingApiResponse
}

export interface DriftmeldingErrorAction extends Action<SettingsActionTypes.DriftmeldingError> {
    error: string | Error
}

export type InfoBannerLoadingAction = Action<SettingsActionTypes.InfoBannerLoading>
export type InfoBannerLoadedAction = Action<SettingsActionTypes.InfoBannerLoaded>

export interface InfoBannerSuccessAction extends Action<SettingsActionTypes.InfoBannerSuccess> {
    payload: InfoBannerApiResponse
}

export interface InfoBannerErrorAction extends Action<SettingsActionTypes.InfoBannerError> {
    error: string | Error
}

export type SettingsHideMaintenanceMessageAction =
    Action<SettingsActionTypes.HideMaintenanceMessage>

export type SettingsAction =
    | DriftmeldingLoadingAction
    | DriftmeldingLoadedAction
    | DriftmeldingSuccessAction
    | DriftmeldingErrorAction
    | InfoBannerLoadingAction
    | InfoBannerLoadedAction
    | InfoBannerSuccessAction
    | InfoBannerErrorAction
    | SettingsHideMaintenanceMessageAction

// =============================================================================
// State
// -----------------------------------------------------------------------------

export interface MaintenanceMessageState extends MaintenanceMessage {
    /**
     * Hides the message until next app load when closed by the user.
     */
    userHidden: boolean
}

export interface SettingsState {
    loading: boolean

    /**
     * Recipe IDs of the currently active dinners of the week.
     */
    //dinnersOfTheWeek: string[];

    /**
     * A message displayed to the user during maintenance.
     */
    maintenanceMessage: MaintenanceMessageState

    infoBanner: InfoBannerApiResponse | null
    infoBannerLoading: boolean
}

// =============================================================================
// API types
// -----------------------------------------------------------------------------

export interface SettingsApiConfig {
    url: string
    endpoint: string
    token: string
}

interface MaintenanceMessage {
    operationsBody: string
    operationsIsActive: boolean
    operationsTitle: string
}

export interface DriftmeldingApiResponse {
    appMaintenanceMessageAndroid: MaintenanceMessage
    appMaintenanceMessageIOS: MaintenanceMessage
}

export interface InfoBannerApiResponse {
    banner: {
        id: string
        content: {
            icon: string | null
            text: string
        }
        dialogContent: null | {
            title?: string
            description?: string
            useDialogWindow?: boolean
            externalLink?: {
                label?: string
                url?: string
            }
            image?: {
                url?: string
                altText?: string
            }
        }
        visibilityPeriod: {
            startDate: string
            endDate: string
        }
        visibilityOverrides: {
            hideForLoggedIn: boolean
            hideForLoggedOut: boolean
        }
    } | null
}
